import { useMemo } from "react";

const CONFETTI_COLORS = [
  "#2d6a5a",
  "#d4a853",
  "#e07a5f",
  "#5fa8d3",
  "#9b72cf",
  "#7cbf6e",
];

// Confetti is a one-shot burst from the middle of its positioned parent,
// for small wins: a finished story, a reached daily goal. Mount it to fire;
// the pieces fade out on their own (and don't show at all with reduced
// motion, see index.css).
export function Confetti({ count = 32 }: { count?: number }) {
  const pieces = useMemo(
    () =>
      Array.from({ length: count }, (_, idx) => {
        const angle = (idx / count) * Math.PI * 2 + Math.random() * 0.4;
        const distance = 70 + Math.random() * 90;
        return {
          dx: Math.cos(angle) * distance,
          // Biased upward, like a popper.
          dy: Math.sin(angle) * distance * 0.8 - 30,
          spin: Math.random() * 720 - 360,
          color: CONFETTI_COLORS[idx % CONFETTI_COLORS.length],
          delay: Math.random() * 90,
          round: idx % 3 === 0,
        };
      }),
    [count],
  );
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute left-1/2 top-1/2 z-10 h-0 w-0"
    >
      {pieces.map((piece, idx) => (
        <span
          key={idx}
          className={`animate-confetti absolute block ${
            piece.round ? "h-2 w-2 rounded-full" : "h-2.5 w-1.5 rounded-[1px]"
          }`}
          style={
            {
              backgroundColor: piece.color,
              animationDelay: `${piece.delay}ms`,
              "--dx": `${piece.dx}px`,
              "--dy": `${piece.dy}px`,
              "--spin": `${piece.spin}deg`,
            } as React.CSSProperties
          }
        />
      ))}
    </div>
  );
}
